import type { Instrumentation } from "@coremonit/types";
import type { WizardData } from "../wizardStore";
import { OptionGrid, StepHeader } from "./common";
import { Zap, LineChart, Radio, Radar } from "lucide-react";

const OPTIONS: Array<{ value: Instrumentation; label: string; description?: string; badge?: string }> = [
  { value: "opentelemetry",  label: "OpenTelemetry", description: "The recommended vendor-neutral standard.", badge: "RECOMMENDED" },
  { value: "prometheus",     label: "Prometheus",    description: "Pull-based metrics scraping." },
  { value: "jaeger",         label: "Jaeger",        description: "CNCF distributed tracing." },
  { value: "zipkin",         label: "Zipkin",        description: "OG distributed tracing project." },
  { value: "grafana-agent",  label: "Grafana Agent", description: "Push metrics / traces / logs into Loki+Tempo+Mimir." },
  { value: "datadog-agent",  label: "Datadog Agent", description: "Datadog APM sidecar." },
  { value: "newrelic-agent", label: "New Relic Agent", description: "New Relic APM." },
  { value: "elastic-apm",    label: "Elastic APM",   description: "Elastic APM Server." },
  { value: "dynatrace",      label: "Dynatrace",     description: "OneAgent." },
  { value: "opentracing",    label: "OpenTracing",   description: "Legacy — will be sunset." },
];

interface Props { data: WizardData; update: (p: Partial<WizardData>) => void }

export function Step3Instrumentation({ data, update }: Props) {
  const toggle = (v: Instrumentation) => {
    const set = new Set(data.instrumentation);
    if (set.has(v)) set.delete(v);
    else set.add(v);
    update({ instrumentation: [...set] });
  };
  return (
    <div>
      <StepHeader title="Instrumentation" description="Select one or more instrumentation sources. OpenTelemetry alone covers metrics + traces + logs and is recommended for new services." />
      <OptionGrid<Instrumentation>
        value={data.instrumentation}
        onChange={toggle}
        options={OPTIONS.map((o) => ({ ...o, icon: <LineChart size={14} /> }))}
        cols={3}
      />
    </div>
  );
}
